import type { ReactNode } from 'react';

type Props = {
  title: string;
  /** Right of the title — e.g. "Edit address". */
  action?: ReactNode;
  children: ReactNode;
  /** The last section carries no divider under it. */
  isLast?: boolean;
};

/** A titled block of the Ship Card page, closed by a full-width hairline
 *  (partner Figma 2026-10-08). */
export function ShipSection({ title, action, children, isLast = false }: Props) {
  return (
    <section className="flex flex-col">
      <div className="flex flex-col gap-2 px-5 py-5">
        <div className="flex items-center justify-between gap-3">
          <h2 className="m-0 text-[20px] font-semibold leading-[28px] tracking-[-0.45px] text-[var(--co-ShipCard-titleColor,#FFFFFF)]">
            {title}
          </h2>
          {action}
        </div>
        {children}
      </div>
      {!isLast && <span aria-hidden className="h-px w-full bg-[var(--co-ShipCard-divider,rgba(255,255,255,0.03))]" />}
    </section>
  );
}
